// extracted by mini-css-extract-plugin
export var active = "_81-a";
export var activeIndicator = "_81-8";
export var animate = "_81-9";
export var disabled = "_81-b";
export var fullWidth = "_81-2";
export var lg = "_81-7";
export var md = "_81-6";
export var redoButtonTabGroup = "_81-0";
export var sm = "_81-5";
export var tabButton = "_81-3";
export var tabButtonsContainer = "_81-1";
export var xs = "_81-4";